<script>
/* jshint esversion: 6 */
import { computed, watch, inject } from 'vue';
import './../func.common.js';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'FileUploadDesigned',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'hinted': {type:String},
        'id': { type: String, default: ''}, 
        'schemaId': {type: Number, default: 0}, 
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'disabled': {type: Boolean},
        'formBox': { type: [Object], default: function() { return {};} }, 
    },
    setup(props) {

        const validateChild = inject('validateChild');
        let isDragging = false;
        let checkArray = {
        idLabel: `fileToUpload${props.schema.model}`,
        tdPreview: `td${props.schema.model}`,
        fileUpload: props.schema.fileModel,
        dragDrop: `drag${props.schema.model}`,
        toParent: {
            'id' : props.schemaId,
            'model': props.schema.model,
            'validator' : props.schema.validator,
        }
        }

        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(helperName, (newVal, oldVal) => { 
            if (validateChild) {
                validateChild(checkArray.toParent);
            }
        });

        function dragover(e) { 
            e.preventDefault();
            isDragging = true; 
        }

        function dragleave(e) {
            e.preventDefault();
            isDragging = false;
        }

        function onDrop(e) {
            e.preventDefault();
            isDragging = false;
            fileChange(e);
        }

        function fileChange(e) {
            //empty model.files
            props.model[props.schema.fileModel] = [];
            props.model[props.schema.model] = null;

            //file Variable
            var files = e.target.files || e.dataTransfer.files; 

            props.model[props.schema.model] = files[0].name;
            props.model[props.schema.fileModel] = files[0];
        }

        function trashIt() {
            props.model[props.schema.fileModel] = [];
            props.model[props.schema.model] = null;
        }

        return {
            isDragging,
            checkArray,
            helperName,
            trashIt,
            dragover,
            dragleave,
            onDrop,
            fileChange
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fileUploadDesigned(
        :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        .field-wrap
            label(v-if="schema.label && schema.label.length > 0" v-html="schema.label")
            .uploadBox(
                :style="disabled === true ? 'cursor:not-allowed; opacity: 0.5': ''"
            )
                #drop_zone(
                    @drop="onDrop"
                    @dragover="dragover"
                    @dragleave="dragleave"
                )
                    input.inputUploadFile(
                        name="filesToUpload[]"
                        :id="checkArray.idLabel"
                        type="file" 
                        multiple="false"  
                        @change="fileChange"
                        :style="disabled === true ? 'pointer-events:none': ''"
                    )
                    label(:for="checkArray.idLabel" class="file-label" :style="disabled === true ? 'pointer-events:none': ''")
                        .uploadBackgroundIcon 
                            .iconWidth
                                font-awesome-icon(icon="fa-solid fa-arrow-up-from-bracket")
                            .uploadText Zum Upload Datei hier hinein ziehen oder das Symbol anklicken

                div.fileNameData Dateiname:  
                    .row.align-items-start(v-if="model[schema.model] !== null")
                        .col-10.fileNameString {{model[schema.model] }}
                        .col-1.fileNameIcon(@click="trashIt" :style="disabled === true ? 'pointer-events:none': ''")
                            font-awesome-icon(icon="fa-regular fa-trash-can")
            template(v-if="schema.errorShow === true")
                br
                .vueFormSmall.labelred(v-if="schema.errorShow === true")
                    font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                    | &nbsp; Fehler in der/den Datei/en
                    ul
                        template(v-for="item in schema.errorText")
                            li(v-html="item")
                .row.fieldInput.col-12
                    .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
</template>